import Header from "./components/Header/Header";
import Hero from "./components/Hero/Hero";
import Pillars from "./components/Pillars/Pillars";
import Projects from "./components/Projects/Projects";
import Security from "./components/Security/Security";
import Process from "./components/Process/Process";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Footer/Footer";
import Divider from "./components/Divider/Divider";
import WhatsAppButton from "./components/WhatsAppButton/WhatsAppButton";

const WHITE = "#ffffff";
const OFF = "#f5f7fa";
const DARK = "#0a0b0d";

export default function App() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Pillars />
        <Divider from={WHITE} to={OFF} variant="wave" />
        <Projects />
        <Divider from={OFF} to={WHITE} variant="wave-alt" />
        <Security />
        <Divider from={WHITE} to={DARK} variant="wave-alt" />
        <Process />
        <Divider from={DARK} to={WHITE} variant="wave" />
        <Contact />
        <Divider from={WHITE} to={DARK} variant="curve" />
      </main>
      <Footer />
      <WhatsAppButton />
    </>
  );
}
